import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "configContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_headertop = _resolveComponent("headertop");
  const _component_slidedata = _resolveComponent("slidedata");
  const _component_mapdecoration = _resolveComponent("mapdecoration");
  const _component_pointdata = _resolveComponent("pointdata");
  const _component_typedata = _resolveComponent("typedata");
  const _component_routetype = _resolveComponent("routetype");
  const _component_routedata = _resolveComponent("routedata");
  const _component_maptools = _resolveComponent("maptools");
  const _component_dragcontent = _resolveComponent("dragcontent");
  const _component_domeditor = _resolveComponent("domeditor");
  const _component_mapmodule = _resolveComponent("mapmodule");
  const _component_sourcematerial = _resolveComponent("sourcematerial");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_headertop, {
    mapform: $data.form,
    onSave: $options.saveHandle,
    onPercentage: $options.percentageChange,
    onIsMobile: $options.changeScreen
  }, null, 8, ["mapform", "onSave", "onPercentage", "onIsMobile"]), $data.form.title && $data.formlabel && $data.formoption && $data.formfield ? (_openBlock(), _createBlock(_component_slidedata, {
    key: 0,
    ref: "slidedata",
    isMobile: $data.isMobile,
    form: $data.form,
    formlabel: $data.formlabel,
    formoption: $data.formoption,
    formfield: $data.formfield,
    seniordata: $data.senior,
    style: _normalizeStyle($data.style),
    pointlist: $data.pointList,
    typelist: $data.typeList,
    isadd: $data.isAdd,
    routetypelist: $data.rtypeList,
    routelist: $data.routeList,
    maptemplate: $data.cTemplateScore,
    decorationstruct: $data.sourcestructList,
    onBasic: $options.basicHandle,
    onFileList: $options.fileHandle,
    onPoint: $options.pointHandle,
    onType: $options.typeHandle,
    onLaunch: $options.launchHandle,
    onRoutetype: $options.routetypeHandle,
    onRoute: $options.routehandle,
    onSwitchNav: $options.switchNav,
    onOpenSource: $options.openSourceMaterial,
    onShadowList: $options.mapShadowList
  }, null, 8, ["isMobile", "form", "formlabel", "formoption", "formfield", "seniordata", "style", "pointlist", "typelist", "isadd", "routetypelist", "routelist", "maptemplate", "decorationstruct", "onBasic", "onFileList", "onPoint", "onType", "onLaunch", "onRoutetype", "onRoute", "onSwitchNav", "onOpenSource", "onShadowList"])) : _createCommentVNode("", true), _createVNode(_component_mapdecoration, {
    ref: "mapdecortaion"
  }, null, 512), $data.form.title && $data.formoption ? (_openBlock(), _createBlock(_component_pointdata, {
    key: 1,
    ref: "pointdata",
    mapform: $data.form,
    mapformoption: $data.formoption,
    isadd: $data.pisAdd,
    form: $data.pform,
    formlabel: $data.pformlabel,
    formoption: $data.pformoption,
    formfield: $data.pformfield,
    coordinate: $data.coordinate,
    isMobile: $data.isMobile,
    typelist: $data.typeList,
    onSubmit: $options.savePointHandle,
    onStylechange: $options.pointstyleChange,
    onOpenSource: $options.openSourceMaterial
  }, null, 8, ["mapform", "mapformoption", "isadd", "form", "formlabel", "formoption", "formfield", "coordinate", "isMobile", "typelist", "onSubmit", "onStylechange", "onOpenSource"])) : _createCommentVNode("", true), _createVNode(_component_typedata, {
    ref: "typedata",
    form: $data.tform,
    formlabel: $data.tformlabel,
    formoption: $data.tformoption,
    formfield: $data.tformfield,
    isadd: $data.tisAdd,
    mapoptions: $data.mapoptions,
    onSubmit: $options.savetypeHandle,
    onOpenSource: $options.openSourceMaterial
  }, null, 8, ["form", "formlabel", "formoption", "formfield", "isadd", "mapoptions", "onSubmit", "onOpenSource"]), _createVNode(_component_routetype, {
    ref: "routetype",
    form: $data.rtform,
    formlabel: $data.rtformlabel,
    formoption: $data.rtformoption,
    formfield: $data.rtformfield,
    isadd: $data.rtisAdd,
    mapoptions: $data.mapoptions,
    onSubmit: $options.saveroutetypeHandle
  }, null, 8, ["form", "formlabel", "formoption", "formfield", "isadd", "mapoptions", "onSubmit"]), _createVNode(_component_routedata, {
    ref: "routedata",
    isadd: $data.risAdd,
    form: $data.rform,
    formlabel: $data.rformlabel,
    formoption: $data.rformoption,
    formfield: $data.rformfield,
    typelist: $data.rtypeList,
    pointlist: $data.pointList,
    onSubmit: $options.saveRouteHandle,
    onClearroute: $options.clearRoutesource,
    onRoutepoint: $options.getRoutePoint
  }, null, 8, ["isadd", "form", "formlabel", "formoption", "formfield", "typelist", "pointlist", "onSubmit", "onClearroute", "onRoutepoint"]), _createVNode(_component_maptools, {
    maptemplate: $data.cTemplateScore,
    list: $data.culturaltransferList,
    drawelement: $data.maplayer.drawelement
  }, null, 8, ["maptemplate", "list", "drawelement"]), _createVNode(_component_dragcontent, {
    ref: "dragcontent",
    value: $data.dragNode
  }, null, 8, ["value"]), _createElementVNode("div", {
    class: _normalizeClass(["mapwrap", [{
      'active': $data.mainActive
    }, {
      'isMobile': $data.isMobile
    }]]),
    onDragover: _cache[0] || (_cache[0] = (...args) => $options.pichandleDragOver && $options.pichandleDragOver(...args))
  }, [$data.isloadingmap ? (_openBlock(), _createBlock(_component_domeditor, {
    key: 0,
    ref: "domeditor",
    show: $data.domeditorflag,
    value: $data.ceditorData,
    isMobile: $data.isMobile,
    onHide: $options.domeditorHide,
    onAddNode: $options.addNodeHandle,
    onSelectNode: $options.selectNodeHandle,
    onSavetrEndNode: $options.savetrEndNodeHandle,
    onChangestyle: $options.changestyleHandle,
    onDeleteNode: $options.deleteNodeHandle,
    onDrop: $options.pichandleDrop
  }, null, 8, ["show", "value", "isMobile", "onHide", "onAddNode", "onSelectNode", "onSavetrEndNode", "onChangestyle", "onDeleteNode", "onDrop"])) : _createCommentVNode("", true), _createVNode(_component_mapmodule, {
    ref: "mapmodule",
    id: 0,
    style: _normalizeStyle($data.style),
    mapform: $data.form,
    typelist: $data.typeList,
    isloadingmap: $data.isloadingmap,
    maplayer: $data.maplayer,
    viewInfo: $data.viewInfo,
    streetcode: $data.streetcode,
    mappointList: $data.mappointList,
    culturalList: $data.culturalList,
    maptemplate: $data.cTemplateScore,
    isMobile: $data.isMobile,
    routelist: $data.routeList,
    senior: $data.senior,
    rtypelist: $data.rtypeList,
    editorlist: $data.ceditorData,
    editordata: $data.editorData,
    domeditorflag: $data.domeditorflag,
    onTypeselect: $options.typeClick,
    onMarkermoveend: $options.markermoveend,
    onDrop: $options.pichandleDrop,
    onDomclick: $options.mapNodeclick
  }, null, 8, ["style", "mapform", "typelist", "isloadingmap", "maplayer", "viewInfo", "streetcode", "mappointList", "culturalList", "maptemplate", "isMobile", "routelist", "senior", "rtypelist", "editorlist", "editordata", "domeditorflag", "onTypeselect", "onMarkermoveend", "onDrop", "onDomclick"])], 34), $data.sourcestructList.length > 0 ? (_openBlock(), _createBlock(_component_sourcematerial, {
    key: 2,
    ref: "sourcematerial",
    value: $data.sourcestructList,
    onSubmit: $options.setSourceMaterial
  }, null, 8, ["value", "onSubmit"])) : _createCommentVNode("", true)]);
}